import React from 'react';
import Styles from './styles.module.css';

type RecruitTitleProps = {
  title: string,
  desc: string,
};

// セクションの見出し。学生アプリの RecruitSectionHeader と同じ(アクセントの縦線＋タイトル＋ひとこと説明)。
const RecruitPageTitle: React.FC<RecruitTitleProps> = React.memo(({ title, desc }) => {

  return (
    <>
    <div className={Styles.title}>
      <div className={Styles.title_row}>
        <span className={Styles.title_bar} />
        <h3>{title}</h3>
      </div>
      {desc && <p>{desc}</p>}
    </div>
    </>
  );
});

export default RecruitPageTitle;
